import { useLanguage } from "../../../i18n/LanguageContext";

export default function KeyValueBlock({ block }) {
  const { language } = useLanguage();

  const c = block.content || {};
  const translated = block.translated_content || {};

  const getTranslation = (chineseValue, translatedValue) => {
    if (language === "zh") {
      return chineseValue || null;
    }

    if (language === "es" || language === "ru") {
      return translatedValue || null;
    }

    return null;
  };

  const labelTranslation = getTranslation(
    c.label_zh,
    translated.label
  );

  const valueTranslation = getTranslation(
    c.value_zh,
    translated.value
  );

  return (
    <div
      style={{
        padding: "18px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Canonical English label */}
      <div
        style={{
          fontSize: "18px",
          fontWeight: "700",
        }}
      >
        {c.label_en}
      </div>

      {/* Selected-language label */}
      {labelTranslation && (
        <div
          style={{
            color: "#6b7280",
            marginTop: "3px",
          }}
        >
          {labelTranslation}
        </div>
      )}

      {/* Canonical English value */}
      <div
        style={{
          marginTop: "14px",
          lineHeight: "1.65",
        }}
      >
        {c.value_en}
      </div>

      {/* Selected-language learning aid */}
      {valueTranslation && (
        <div
          style={{
            marginTop: "7px",
            color: "#6b7280",
            lineHeight: "1.65",
          }}
        >
          {valueTranslation}
        </div>
      )}
    </div>
  );
}